import React from 'react';

export function XIcon() {
  // https://lucide.dev/icons/x
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </g>
  );
}
